._paymentRequiredModal_uaioi_1 {
  position: fixed !important;
  top: calc(50% - 120px) !important;
  left: calc(50% - 200px) !important;
  z-index: 9900 !important;
  width: 400px !important;
}